<template>
  <div class="prompt">
    <img src="../../assets/images/newicon/nodata.png" />
    <div class="nodata">童鞋，暂时木有内容哟~</div>
  </div>
</template>

<script>
export default {
  name: "prompt",
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.prompt {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 430px;
  background: #fff;
  width: 100%;
  img {
    width: 462px;
  }
  .nodata{
    margin-top: -40px;
  }
}
</style>
